import React from 'react'

import BackButton from '../components/BackButton/index'
import TitleWithApply from '../components/TitleWithApply/index'
import Subtitle from '../components/Subtitle/index'
import Section from '../components/Section/index'
import Paragraph from '../components/Paragraph/index'
import Heading from '../components/Heading/index'
import LI from '../components/LI/index'
import OL from '../components/OL/index'
import UL from '../components/UL/index'

export default function LeadQA() {
  return (
    <>
      <BackButton />
      <TitleWithApply>Lead QA - manual testing expert</TitleWithApply>
      <Subtitle>Engineering - remote</Subtitle>
      <Section>
        <Heading>About Peer</Heading>
        <Paragraph>
          Peer creates a gamified metaverse on a proprietary immersive 3D map. Our platform includes
          a mobile app and a web marketplace, with interactions driven by location sharing.
        </Paragraph>
        <Paragraph>
          We are building a meta-world that becomes a literal peer to your real world.
        </Paragraph>
        <Paragraph>
          The team you will be joining is not just playing around with social media or gaming - we
          are a team of tech, product, art, and design seniors creating technologies to enable
          innovative social and gaming experiences that have not existed before. And we are just
          getting started.
        </Paragraph>
      </Section>

      <Section>
        <Heading>About You:</Heading>
        <Paragraph>
          We seek a highly skilled and experienced Lead QA with a mobile gaming testing background
          for large audiences. Your keen eye for detail and UX is coupled with strong experience
          designing, developing, and maintaining manual testing of mobile apps.
        </Paragraph>
      </Section>

      <Section>
        <Heading>Mission:</Heading>
        <Paragraph>
          This role requires working with cross-functional teams to deliver a product that meets
          user needs and business objectives.{' '}
        </Paragraph>
        <OL>
          <LI>
            Test Strategy and Planning: Develop and implement comprehensive test strategies for our
            mobile applications.
          </LI>
          <LI>
            Defect Tracking and Reporting: Manage the defect lifecycle, from identification to
            resolution.
          </LI>
          <LI>
            Manual testing: We have two mobile applications (IOS and Android). We are creating and
            launching a lot and moving fast. We need you to be like a proactive pest, which will be
            close to a developer's nightmare.
          </LI>
          <LI>
            That said, we are not looking for a nasty person. Your communication skills need to be
            impeccably good—we are seeking a clear, organized, detail- oriented tester.
          </LI>
          <LI>
            Cross-functional collaboration: Work closely with design and engineering teams to ensure
            the product is developed according to specifications and meets quality standards.
          </LI>
        </OL>
      </Section>

      <Section>
        <Heading>The role requires:</Heading>
        <OL>
          <LI>Bachelor's degree in Computer Science, Engineering, or related field.</LI>
          <LI>
            Proven Lead QA role experience oriented towards a significant mobile app audience.
          </LI>
          <LI>Proven experience in managing QA teams.</LI>
          <LI>Extensive experience in manual mobile testing</LI>
          <LI>Multiple shipped products and projects.</LI>
          <LI>Strong technical, analytical, and problem-solving skills.</LI>
          <LI>Familiarity with mobile and web app development processes and platforms.</LI>
          <LI>
            Strong experience with bug reporting and collaboration tools (e.g., Jira, Notion).
          </LI>
          <LI>Familiarity with app store guidelines (iOS App Store, Google Play).</LI>
          <LI>Excellent communication and leadership skills.</LI>
          <LI>
            Detail-oriented, you diligently discover and report bugs so developers and others can
            easily understand, reproduce, and act upon them.
          </LI>
          <LI>Experience with Appium for mobile automation testing is a plus</LI>
        </OL>
      </Section>

      <Section>
        <Heading>Benefits</Heading>
        <UL>
          <LI>Competitive salary.</LI>
          <LI>Opportunity to work on cutting-edge projects and innovative technologies</LI>
          <LI>Professional development opportunities and continuous learning</LI>
          <LI>Collaborative and inclusive work culture</LI>
          <LI>Full remote work</LI>
        </UL>
      </Section>
    </>
  )
}
